// extracted by extract-css-chunks-webpack-plugin
module.exports = {"textarea":"_3XqkKJ","default":"dmBFM9","fullWidth":"eLP2gz","noResize":"_1en50-"};